
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-subject-action-request",
      function () {
        return require("private-next-pages/data-subject-action-request.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-subject-action-request"])
      });
    }
  